import React from 'react';
import { BsInstagram, BsYoutube } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://www.youtube.com/channel/UCRRuM3vHgDCyR9ONPP64PDA" target="_blank" rel="noopener noreferrer">
        <BsYoutube />
      </a>
    </div>
    <div>
      <a href="https://www.facebook.com/amitnepali1810" target="_blank" rel="noopener noreferrer">
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href="https://www.instagram.com/amitnepali1810/" target="_blank" rel="noopener noreferrer">
      <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;